export default "__VITE_ASSET__ss9_me$a__"